module.exports = __webpack_public_path__ + "img/37.a822b60b.jpg";